import { ArrowUturnLeftIcon } from "@heroicons/react/16/solid";
import { PlusIcon } from "@heroicons/react/20/solid";
import type { PropsWithChildren } from "react";
import { useState } from "react";

import Button from "~/components/buttons/Button";
import Headline from "~/components/Headline";
import LoadingSpinner from "~/components/LoadingSpinners/LoadingSpinner";
import { INVOICES_INDEX_PATH, INVOICES_PENDING_PATH } from "~/constants/appRoutes.ts";
import CreateInvoiceSidebar from "~/modules/billing/components/InvoicePageHeader/components/CreateInvoiceSidebar";

type Props = PropsWithChildren & {
	currentPage: "invoices" | "pending";
	userCanManageInvoices: boolean;
	showLoadingSpinner?: boolean;
};

const InvoicePageHeader = ({
	currentPage,
	children,
	showLoadingSpinner = false,
	userCanManageInvoices,
}: Props) => {
	const [showCreateInvoiceSidebar, setShowCreateInvoiceSidebar] = useState<boolean>(false);
	const isIndexView = currentPage === "invoices";
	return <div className="z-50 mx-auto mb-4 w-full space-y-4 bg-white px-8 py-4 ">
		<div className="flex items-center gap-x-2">
			<Headline type="h2">{isIndexView ? "Übersicht" : "Neue Projektrechnung"}</Headline>
			{children}
			{showLoadingSpinner && <div className="flex items-center gap-x-2 text-sm font-bold text-gray-500"><LoadingSpinner theme="neutral"/>Laden ...</div>}
			<div className="ml-auto flex items-center gap-x-2">
				{isIndexView && <Button theme="secondary"
										to={INVOICES_PENDING_PATH}
				><PlusIcon className="size-5" />
					Neue Projektrechnung
				</Button>}
				{!isIndexView && <Button theme="primary"
										 to={INVOICES_INDEX_PATH}>
					<ArrowUturnLeftIcon className="size-5" />
					Zurück zur Übersicht
				</Button>}
				{userCanManageInvoices && isIndexView && <Button theme="secondary"
												  onClick={() => setShowCreateInvoiceSidebar(true)}><PlusIcon className="size-5" />
					Neue Rechnung
				</Button>}
			</div>
		</div>

		{userCanManageInvoices && <CreateInvoiceSidebar isOpen={showCreateInvoiceSidebar}
														onClose={() => setShowCreateInvoiceSidebar(false)} />}
	</div>;
};

export default InvoicePageHeader;